export default "__VITE_ASSET__6_Jz_XLB__"